import { Link } from "react-router-dom";
import moment from "moment";
import { PortableText } from "@portabletext/react";

const serializers = {
  marks: {
    link: ({children, value}) => {
      const rel = !value.href.startsWith('/') ? 'noreferrer noopener' : undefined
      const target = '_blank'
      const className = 'link'
      return (
        <a href={value.href} rel={rel} target={target} className={className}>
          {children}
        </a>
      )
    },
  },
};
// new/ blog component
const BlogContent = ({blogContent})  => {
    return(
        <div className="row">
        {Array.isArray(blogContent) && blogContent.slice(0, 3).map((blogContentItem) => (
        <div className="col-sm-6 col-md-6 col-lg-4" key={blogContentItem.id}>
              <div className="blog-panel"> 
                <div className="blog-img"><Link to={`/news/${blogContentItem.blogSlug}`}><img src={blogContentItem.image}/></Link></div>
                <div className="blog-content"> 
                  <div className="blog-meta-container"> 
                    <div className="meta-date"> <i className="far fa-calendar-alt"></i><span>
                      {moment(blogContentItem.metaDate).format('DD MMMM YYYY')}
                      </span></div>
                  </div>
                  <h3 className="blog-title"><Link to={`/news/${blogContentItem.blogSlug}`}>{blogContentItem.blogTitle}</Link></h3>
                  <span className="heading-desc"> <PortableText value={blogContentItem.blogDesc} components={serializers} ></PortableText></span>
                  <div className="read-more">
                    <Link to={`/news/${blogContentItem.blogSlug}`}>read more</Link>
                  </div>
                </div>
              </div>
            </div>
        ))}
        </div>   
    );
}

export default BlogContent;